import gql from 'graphql-tag';

export const getQuotationsList = gql`
query getQuotationsList(
    $input: GetListQuotationsInput) {
      getQuotationsList(getListQuotationsInput: $input) {
        id
        leadId
        vehicle
        vehicleId
        vehicleIsConfig
        creationDate
        modificationDate
        amount
        status
        temperature
        contractDate
        saleDate
      }
  }
`;
